import mod from "react/jsx-dev-runtime";
export default mod;
export const { Fragment, jsxDEV } = mod;